<template>
 <div>
  <div class="bg-default-dashboard" >
    <div class=" py-lg-8 pt-lg-5">
      <b-container fluid style="width: 100%; position: relative;">
        <!-- <div class="header-body "  > -->
          <b-row class="mb-2">
            <b-col>
              <h1 class="text-white">List Document Template</h1>
            </b-col>
          </b-row>
          <!--NEW GRID START HERE-->
          <b-row class="mt-4">
            <b-col md="12">
          <dataset style="width: 100%;" v-slot="{ ds }" :ds-data="tableData"
                :ds-sortby="['name', 'active_status', 'create_at']"
                :ds-search-in="['name', 'active_status', 'create_at']">
                <div class="row" style="padding-bottom: 15px;" :data-page-count="ds.dsPagecount">
                  <!-- data grid - data per-page -->
                  <div class="col-md-2" style="
                      color: #ffffff;
                      font-family: Open Sans, sans-serif !important;
                      font-size: 0.875rem;
                    ">
                    <dataset-show class="dataset-style"/>
                  </div>
                  <!-- end data grid - data per-page -->


                  <!-- data grid - search-->
                  <div class="col-md-8">
                    <dataset-search ds-search-placeholder="Search..." />
                  </div>

                  <!-- create new -->
                  <div class="col-md-2 text-right">
                    <base-button type="primary" @click="navigateToAdd"><i class="fa fa-plus mr-1"></i>Template</base-button>
                  </div>


                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <table style="width: 100%;" id="my-table">
                      <!--<table style="width: 100%;" class="table table-striped d-md-table">-->
                        <thead
                          style="background-color: #23454A; color: white; font-size: small; border-bottom: 20px solid #082A2F;">
                          <tr>
                            <!-- <th scope="col">#</th> -->
                            <th v-for="(th, index) in obj_pagination.cols" :key="th.field" :class="['sort', th.sort]"
                              @click="click($event, index)">
                              {{ th.name }} <i class="gg-select float-right"></i>
                            </th>
                          </tr>
                        </thead>
                        <dataset-item tag="tbody">
                          <template #default="{ row, rowIndex }">
                            <tr
                              style="background-color: #3a656b; color: white; font-size: smaller; border-bottom:  20px solid #082A2F;">
                              <!-- <th scope="row">{{ rowIndex + 1 }}</th> -->
                              <td class="tr-td-table-new" style="min-width: 150px;">{{ row.name }}</td>
                              <td class="tr-td-table-new" style="min-width: 150px;">
                                <i class="fa fa-xs fa-circle mr-1" style="color: #46D275;"  v-if="row.active_status=='ACTIVE'"></i>
                                <i class="fa fa-xs fa-circle mr-1"  v-else></i>{{ row.active_status }}
                              </td>
                              <td class="tr-td-table-new" style="min-width: 150px;">{{ row.created_at }}</td>
                              <td class="tr-td-table-new" style="min-width: 100px;">
                                <div >
                          <b-link :to="`Edit/${row.id}`" class="mr-3 mt-4" >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_1130_20)">
                              <path d="M2.81399 15.4667L1.54732 20.9333C1.50363 21.1332 1.50513 21.3403 1.55171 21.5394C1.59829 21.7386 1.68878 21.9249 1.81657 22.0846C1.94435 22.2444 2.10621 22.3735 2.29031 22.4627C2.47441 22.5519 2.6761 22.5988 2.88066 22.6C2.97597 22.6096 3.07201 22.6096 3.16732 22.6L8.66732 21.3333L19.2273 10.8133L13.334 4.93335L2.81399 15.4667Z" fill="#FF5C00"/>
                              <path d="M22.5471 5.54667L18.6138 1.61333C18.3552 1.35604 18.0053 1.21161 17.6405 1.21161C17.2757 1.21161 16.9257 1.35604 16.6671 1.61333L14.4805 3.8L20.3671 9.68667L22.5538 7.5C22.6818 7.37139 22.7831 7.2188 22.852 7.05098C22.921 6.88315 22.9561 6.70338 22.9555 6.52195C22.9549 6.34052 22.9185 6.161 22.8484 5.99364C22.7784 5.82629 22.676 5.6744 22.5471 5.54667Z" fill="#FF5C00"/>
                              </g>
                              <defs>
                              <clipPath id="clip0_1130_20">
                              <rect width="24" height="24" fill="white"/>
                              </clipPath>
                              </defs>
                            </svg>
                            </b-link>
                            
                          <b-link class="mr-3" :to="`View/${row.id}/Category/Listing`" style="top: 0;">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.07 4.50002L5.4075 5.16752L5.82 6.00002H9V9.75002H3V4.50002H5.07ZM5.535 3.00002H2.25C2.05109 3.00002 1.86032 3.07904 1.71967 3.21969C1.57902 3.36034 1.5 3.55111 1.5 3.75002V10.5C1.5 10.6989 1.57902 10.8897 1.71967 11.0303C1.86032 11.171 2.05109 11.25 2.25 11.25H9.75C9.94891 11.25 10.1397 11.171 10.2803 11.0303C10.421 10.8897 10.5 10.6989 10.5 10.5V5.25002C10.5 5.05111 10.421 4.86034 10.2803 4.71969C10.1397 4.57904 9.94891 4.50002 9.75 4.50002H6.75L6.21 3.41252C6.1471 3.28769 6.05058 3.18293 5.93131 3.11004C5.81204 3.03715 5.67477 2.99905 5.535 3.00002ZM17.07 4.50002L17.4075 5.16752L17.82 6.00002H21V9.75002H15V4.50002H17.07ZM17.535 3.00002H14.25C14.0511 3.00002 13.8603 3.07904 13.7197 3.21969C13.579 3.36034 13.5 3.55111 13.5 3.75002V10.5C13.5 10.6989 13.579 10.8897 13.7197 11.0303C13.8603 11.171 14.0511 11.25 14.25 11.25H21.75C21.9489 11.25 22.1397 11.171 22.2803 11.0303C22.421 10.8897 22.5 10.6989 22.5 10.5V5.25002C22.5 5.05111 22.421 4.86034 22.2803 4.71969C22.1397 4.57904 21.9489 4.50002 21.75 4.50002H18.75L18.21 3.41252C18.1471 3.28769 18.0506 3.18293 17.9313 3.11004C17.812 3.03715 17.6748 2.99905 17.535 3.00002ZM5.07 14.25L5.4075 14.9175L5.82 15.75H9V19.5H3V14.25H5.07ZM5.535 12.75H2.25C2.05109 12.75 1.86032 12.829 1.71967 12.9697C1.57902 13.1103 1.5 13.3011 1.5 13.5V20.25C1.5 20.4489 1.57902 20.6397 1.71967 20.7803C1.86032 20.921 2.05109 21 2.25 21H9.75C9.94891 21 10.1397 20.921 10.2803 20.7803C10.421 20.6397 10.5 20.4489 10.5 20.25V15C10.5 14.8011 10.421 14.6103 10.2803 14.4697C10.1397 14.329 9.94891 14.25 9.75 14.25H6.75L6.21 13.1625C6.1471 13.0377 6.05058 12.9329 5.93131 12.86C5.81204 12.7872 5.67477 12.749 5.535 12.75ZM17.07 14.25L17.4075 14.9175L17.82 15.75H21V19.5H15V14.25H17.07ZM17.535 12.75H14.25C14.0511 12.75 13.8603 12.829 13.7197 12.9697C13.579 13.1103 13.5 13.3011 13.5 13.5V20.25C13.5 20.4489 13.579 20.6397 13.7197 20.7803C13.8603 20.921 14.0511 21 14.25 21H21.75C21.9489 21 22.1397 20.921 22.2803 20.7803C22.421 20.6397 22.5 20.4489 22.5 20.25V15C22.5 14.8011 22.421 14.6103 22.2803 14.4697C22.1397 14.329 21.9489 14.25 21.75 14.25H18.75L18.21 13.1625C18.1471 13.0377 18.0506 12.9329 17.9313 12.86C17.812 12.7872 17.6748 12.749 17.535 12.75Z" fill="#FF5C00"/>
                            </svg>
                          </b-link>
                          <b-link :to="`View/${row.id}/Document/Listing`" style="color: #FF5C00; font-size:large;" >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM19 9H14V4H5V20H19V9ZM8 7H11V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z" fill="#FF5C00"/>
                            </svg>

                          </b-link>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </dataset-item>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-md-row flex-column justify-content-between align-items-center"
                  style="color: #ffffff; font-family: Open Sans, sans-serif !important; font-size: 0.875rem;">
                  <dataset-info class="mb-2 mb-md-0" />
                  <dataset-pager />
                </div>
          </dataset>
          </b-col>
          </b-row>
          <!--NEW GRID END HERE-->
          <!-- Modal -->
          <b-modal ref="my-modal" centered hide-footer title="" class="bg-dark">
              <div class="d-block text-center">
                <!-- <h3>Hello From My Modal!</h3> -->
                <div class="text-center text-black mt-3 mb-2" >
                  <img src="/img/theme/general/upload.png" alt="">
                  <div class="mt-2">Upload Files Here</div>
                  <div class="mt-1"><small>Files Supported: XSLS</small></div>
                  <div class="mt-2">
                    <base-button type="primary" style="width: 150px;" native-type="submit">Choose File</base-button>
                    <base-button style="background-color:#7A7A7A99 ; color: #BEC0C9; width: 150px; border-color: transparent;" native-type="submit">Save</base-button>
                  </div>
                  <div class="mt-2" style="font-size: 12px; color: grey;">
                    Maximum size : 5MB
                  </div>

                </div>
                <b-row class="justify-content-md-center" v-if="file_uploads==true">
                  <b-col md="6">
                      <base-input >
                        <select class="form-control">
                          <option>Option Excel</option>
                        </select>
                      </base-input>
                    </b-col>
                </b-row>
                <b-row class="justify-content-md-center" v-if="file_uploads==false">
                  <b-col md="6">
                    <div class="text-black text-center">
                      No File Uploaded
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-modal>

      </b-container>

    </div>


  </div>
 </div>
</template>
<script>
import { Select, Option,  Table, TableColumn, } from 'element-ui'
import standardPaginationMix from '@/assets/js/standardPaginationMix.js'
import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'
import { BasePagination } from '@/components';
import axios from '@/util/axios'
import { getAccessByModule } from '@/util/access'
import Fuse from 'fuse.js';
import Dataset from '@/assets/js/customDataset.js';

import {
  DatasetItem,
  DatasetInfo,
  DatasetPager,
  DatasetSearch,
  DatasetShow
} from 'vue-dataset';


  export default {
    // name :"Tracking Template",
    mixins: [standardPaginationMix, ErrorFunctionMixin],
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Dataset,
      DatasetItem,
      DatasetInfo,
      DatasetPager,
      DatasetSearch,
      DatasetShow
    },
    data() {
      return {
        fields: [
          { key: 'name', label: 'Name' },
          { key: 'status', label: 'Status' },
          { key: 'created_at', label: 'Created At' },
          // { key: 'capacity', label: 'Capacity' },
          { key: 'action', label: '' },

        ],
        all_data: [],
        items: [],
        filterOption :[
          {
            label: 5,
            value: 5
          },
          {
            label: 10,
            value: 10
          },
          {
            label: 25,
            value: 25
          },
          {
            label: 50,
            value: 50
          },
        ],
        obj_pagination: {
        cols: [
          {
            name: 'Template Name',
            field: 'name',
            sort: ''
          },
          {
            name: 'Status',
            field: 'active_status',
            sort: ''
          },
          {
            name: 'Created At',
            field: 'created_at',
            sort: ''
          },
          {}
        ],
      },
        selectedFilter:5,
        file_uploads:false,
        rows: 15,
        perPage: 5,
        currentPage: 1,
        tableData: [],
        access: {},
      };
    },
    created() {
    this.access = getAccessByModule('DOC_REPO');
    this.getData();
  },

    methods: {
      navigateToAdd() 
      {
        this.$router.push({path:'/administrator/setup/add'} ); 
      },
      showModal() {
        this.$refs['my-modal'].show()
      },
      generateData(){
        this.all_data = [];
        var status = ["Active", "In Active"];
        // for (let index = 1; index <= this.rows; index++) {
        //   var status_num = 0;
        //   if (index%2==0) {
        //     status_num = 1;
        //   }
        //   var name = "Test "+ index.toString()
        //   this.all_data.push({
        //     id: index,
        //     name : name,
        //     status : status[status_num],
        //     created_at:"24 Juni 2024"
        //   })
        // }



      },
       getData() {
      axios.get('setup/doc_repo/template')
        .then(response => {
          this.tableData = response.data.data
          this.fuseData()
        })
        .catch(error => {
          this.errorFunction(error, this.title)
        })
    },

    fuseData() {
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        threshold: 0.3,
      });
    },
      getPagination(){
        this.items = [];

        let from = 0
        if(this.currentPage==1){
          from = (this.currentPage-1)
        }else{
          from = (this.currentPage-1)*this.perPage;
        }
        // this.rows

        this.items = this.all_data.slice(from,this.perPage*this.currentPage)
        // for (let index = 0; index < this.perPage; index++) {


        // }
        // console.log(this.currentPage)

      },
      // setPagination(perPage){
      //   this.perPage =
      // }
    },
    mounted() {
      this.generateData();
      this.getPagination();
      // console.log(this.currentPage)
      // console.table(this.data)

    }
  };
</script>
<style scoped>
/* Class For Modal */
.modal-content {
  background-color: #306b74;

}

table thead th{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-size: 0.65rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    background-color: #23454A;
    color: white;
    padding: 20px;
    border-bottom: 0px solid #082A2F;
    border-top: 0px solid #e9ecef;
}

.th-table-new {
  padding-top: 35px;
  padding-bottom: 35px;
  padding-left: 20px;
  font-size: small; 
  /*0.65rem;*/
}

.tr-td-table-new {
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 20px;
}

.tr-td-table-new-mdl {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
}


.el-table th.el-table__cell {

    overflow: hidden;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: #23454A;
    color: white;
    padding: 20px;
    border-top: 0px solid #082A2F;
    border-bottom: 0px solid #082A2F;
}
.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 20px solid #082A2F;
    border-top: 0px solid #082A2F;
}
div.el-table .el-table__row {
    background: #3a656b;
    border-bottom: 0 solid #082A2F;


}
div.el-table .el-table__row:hover {
    background: #3a656b;
}

.el-table--border::after, .el-table--group::after, .el-table::before {
    content: '';
    position: absolute;
    background-color: #ebeef500;
    z-index: 1;
}

/deep/ .form-control {
  background-color: #2C545A;
  border-color: #2C545A;
  color: white;

  &:focus {
    background-color: #2C545A;
    border-color: #2C545A;
    /* color: white; */
  }

  &::placeholder {
    color: white;
  }
}

/deep/ .form-control {
  &:focus {
    &::placeholder {
      color: white;
    }
  }
}

.input-group-text {
  background-color: #2C545A;
  ;
  color: white;

  &:focus {
    background-color: #2C545A;
    ;
    border-color: #1D4147;
    color: white;
  }
}

.focused {
  .input-group-text {
    background-color: #2C545A;
  }
}

</style>

